































import {Component, Prop, Vue} from 'vue-property-decorator'
import axios from 'axios';

@Component
export default class EmailOptInOffer extends Vue {

    private timeout: any;

    private mounted() {
        if (!document.cookie.includes('OfferClicked')) {
            this.timeout = setTimeout(this.show, 10000);
        }
    }

    private destroyed() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
    }

    private show() {
        const element = this.$refs.modal as HTMLElement;
        element.style.top = `${window.scrollY}`;
        element.style.display = 'flex';
        element.style.height = '100vh';

        document.body.style.top = `-${window.scrollY}px`;
        document.body.style.position = 'fixed';
        document.body.style.width = '100vw';

        window.addEventListener('keyup', this.onKeyUp);

    }

    private hide() {
        const element = this.$refs.modal as HTMLElement;
        element.style.top = `0`;
        element.style.display = 'none';

        document.body.style.top = '';
        document.body.style.position = '';
        document.body.style.width = '';
    }

    private onKeyUp(e: KeyboardEvent) {
        if (e.key === 'Escape') {
            this.hide();
        }
    }

    private submit() {
        document.cookie = 'OfferClicked'
        this.hide()
    }
}
